// extracted by mini-css-extract-plugin
export var numpadContainer = "_oy-1";
export var phoneButton = "_oy-0";